import { render, staticRenderFns } from "./note_edited_text.vue?vue&type=template&id=e99c4cfc"
import script from "./note_edited_text.vue?vue&type=script&lang=js"
export * from "./note_edited_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports